var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"flex-column"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('el-divider'),_c('div',{staticClass:"tip"},[_vm._v(_vm._s(_vm.tip))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }